import type { ReactNode } from "react"
import React from "react"

import useCheckoutFlowDraftQuote from "~utils/use-checkout-flow-draft-quote"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import CheckoutFlowSummaryContent from "~components/pages/listing/checkout/checkout-flow/checkout-flow-summary-content"

interface Props {
    readonly renderNavButtons: () => ReactNode
}

export default function CheckoutFlowSummarySidebar({
    renderNavButtons,
}: Props) {
    const { listing, isLoadingAvailability } = useCheckoutFlow()
    const { draftQuote, isLoadingDraftQuote } = useCheckoutFlowDraftQuote()

    // For typescript.
    if (!listing) return null

    return (
        <CheckoutFlowSummaryContent
            listing={listing}
            draftQuote={draftQuote}
            isLoading={isLoadingDraftQuote || isLoadingAvailability}
            renderNavButtons={renderNavButtons}
        />
    )
}
